import { ModifierListInterface } from "@/interface/business/item.interface";
import { Modifier } from "@/modules/location/modifier";
import { MODIFIER_LIST_TYPE } from "@/enums/business.enum";
import { ModifierListType, ModifiersType } from "@/types/business/item.type";
import { NAME_LOCAL_NAME_KEY } from "@/enums/orders.enum";
import store from "@/store";

/**
 * ModifierList Class
 * @param {ModifierListInterface} ModifierList
 */
export default class ModifierList implements ModifierListInterface {
  id: string;
  original_name: string;
  original_local_name: string;
  name: string;
  local_name: string;
  type: string;
  min: number;
  max: number;
  quantifiable: boolean;
  order: number;
  modifiers: Modifier[];
  isStaged: boolean;
  constructor(data: ModifierListType) {
    this.id = data.id || "";
    this.name = data.name || "";
    this.original_name = data.original_name ?? data.name ?? "";
    this.original_local_name = data.original_local_name ?? data.local_name ?? "";
    this.local_name = data.local_name || "";
    this.type = data.type || "";
    this.min = data.min || 0;
    this.max = data.max || 100;
    this.quantifiable = data.quantifiable || false;
    this.order = data.order || 0;
    this.modifiers = [];
    this.isStaged = true;
    this.setupModifiers(data);
  }

  setupModifiers(data) {
    // case item selected from the tab
    if (data?.options) {
      return (this.modifiers = data.options.map((modifier: ModifiersType) => {
        const quantity = modifier.quantity || this.min;
        return new Modifier({ ...modifier, quantity });
      }));
    }

    this.modifiers = data.modifiers.map((modifier: ModifiersType) => {
      const quantity = modifier.quantity || this.min;
      return new Modifier({ ...modifier, quantity });
    });
  }

  get modifiersLength(): number {
    if (this.modifiers?.length) {
      return this.modifiers?.length;
    }
    return 0;
  }

  /**
   * Set modifier selected
   * @return {void}
   */
  public setModifiers(): void {
    if (this.type === MODIFIER_LIST_TYPE.SINGLE)
      this.modifiers.map(<ModifiersInterface, Number>(modifier, index): void => {
        if (index === 0) {
          modifier.select();
        }
        return modifier;
      });
  }

  /**
   * check if the modifier is staged or not to be saved to item
   * @param stagedModifiers
   */
  public checkIsStaged(stagedModifiers: Array<ModifiersType>): boolean {
    return !!stagedModifiers.find((item) => item.original_name === this.original_name);
  }
  /**
   * Find index of modifier
   * @param originalCatalogLists
   * @return {number}
   */
  public findIndexOfModifier(originalCatalogLists): number {
    return originalCatalogLists?.findIndex((item) => item.id === this.id);
  }

  /**
   * replace the display with modifiers from the catalog
   * @param catalogModifiers
   */
  public replaceWithCatalogModifiers(catalogModifiers) {
    return catalogModifiers?.map((obj) => this.modifiers?.find((item) => item.id === obj.id) || obj);
  }

  /**
   * get item name by language key
   * @return {string}
   */
  public getDisplayName(): string {
    const { state } = <any>store;
    return this?.[NAME_LOCAL_NAME_KEY[state.App.lang]] || this.name;
  }
}
